import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Downloads from "@/pages/Downloads";

function App() {
  return (
    <div className="App dark">
      <div className="grain-overlay" />
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/downloads" element={<Downloads />} />
            </Routes>
          </BrowserRouter>
        </ReactLenis>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
